export class DestinationDTO {
  _id: string;
  titles: any[];
  active: boolean;
  images: any[];
  createdAt: string;
  location: any;
  apiId: string;
  contexts: any[];
  city: string;
  country: string;
  entryType: string;
  defaultImage: string;

  constructor(destinationDto?: any) {
    destinationDto = destinationDto || {};
    this._id = destinationDto._id || '';
    this.titles = destinationDto.titles || [];
    this.active = destinationDto.active;
    this.images = destinationDto.images || [];
    this.createdAt = destinationDto.createdAt || '';
    this.apiId = destinationDto.apiId || '';
    this.contexts = destinationDto.contexts || [];
    this.location = destinationDto.location || {};
    this.country = destinationDto.country || '';
    this.city = destinationDto.city || '';
    this.entryType = destinationDto.entryType || '';
    this.defaultImage = destinationDto.defaultImage || '';
  }
}
